import ComponentBase from "../abstracts/componentBase";
import ModalHistory from "../modals/modal-history/modalHistory";
import btnHistory from "./templateBtn";

export default class HistoryBtn extends ComponentBase{

    private static idBtn="btn-history";
    private static elementToRender = btnHistory(HistoryBtn.idBtn);
    private modalHistory:ModalHistory;
    

    constructor(
        protected parentElement:HTMLElement
    ){
        super(parentElement,HistoryBtn.idBtn,HistoryBtn.elementToRender);
        this.createModalHistory();
    }

    public openModalHistory(){
        this.elementRendered.addEventListener("click",()=>{
            this.modalHistory.show();
        });
    }

    private createModalHistory(){
        this.modalHistory = new ModalHistory(this.parentElement);
        this.modalHistory.render();
        this.modalHistory.loadBody(()=>{
            console.log("modal loaded")
        });
    }
}